import { create } from "zustand";
import {
  assignClinic,
  assignedClinic,
  assingDoctorToCX,
  bookClinicSlot,
  clinicPrescription,
  clinicsSlots,
  cxAssignedClinic,
  doctorsOfClinic,
  editClinicData,
  editPresApi,
  getClinicAppointments,
  getClinicData,
  getClinicDetails,
  getClinicLocationsApi,
  getClinicsSlots,
  getNearestClinic,
  markPaid,
  patientsAssignedToClinics,
  postClinicData,
  searchClinic,
  uploadImagePres,
  viewPrescriptionApi,
} from "../api";
import { toast } from "react-toastify";
import { TOAST_MESSAGE_CSS } from "modules/utilities/utility";

export const useClinicStore = create((set, get) => ({
  clinicData: {},
  AllclinicData: [],
  isError: false,
  error: null,
  currentAssingedClinic: "",
  clinicsAllData: [],
  nearestClnic: [],
  clinicAppointments: [],
  clinicAppointmentLoading:false,
  doctors: [],
  clinicsAssingedToCx: [],
  slots : [],
  viewPrescriptionData:[],
  prescLoading:false,
  locations: [],
  editClinicLoading: false,
  clinicPresRes:[],
  postClinic: async (payload) => {
    set({ isLoading: true });
    try {
      const response = await postClinicData(payload);
      set({ clinicData: response.data });
      toast.success("Clinic Added Successfully");
    } catch (error) {
      console.log('error', error);
      set({ isError: true });
      toast.error("Failed to Add Clinc");
    } finally {
      set({ isLoading: false });
      const response = await getClinicData();
      set({ AllclinicData: response.data });
    }
  },
  getClinics: async (page) => {
    set({ isLoading: true });
    try {
      const response = await getClinicData(page);
      set({ AllclinicData: response.data });
    } catch (error) {
      console.error(error.message);
    }
  },
  getSearchClinics: async (query) => {
    set({ isLoading: true });
    try {
      const response = await searchClinic(query);
      set({ searchClinicData: response.data });
    } catch (error) {
      console.error(error.message);
    }
  },
  editClinics: async (payload, toast) => {
    set({ editClinicLoading: true });
    try {
      await editClinicData(payload);
      toast.success("Clinic Updated Successfully");
    } catch (error) {
      toast.error("Failed to Updated Clinc");
      console.error(error.message);
    } finally {
      const response = await getClinicData();
      set({ AllclinicData: response.data, editClinicLoading:false });
    }
  },

  addOrUpddateClinicAssingmnet: async (toast, case_id, clinic_id) => {
    set({ isLoading: true });
    try {
      await addOrUpdateAssignedClinic(case_id, clinic_id);
      toast.success("Clinic Deatils updated Successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  },

  getClnicDetails: async (clinic_id) => {
    set({ isLoading: true });
    try {
      const response = await getClinicDetails(clinic_id);
      set({ clinicsAllData: response.data });
    } catch (error) {
      console.error(error);
    }
  },

  nearestClnicDetails: async (locality, pincode) => {
    set({ isLoading: true });
    try {
      const response = await getNearestClinic(locality, pincode);
      set({ nearestClnic: response.data });
    } catch (error) {
      console.error(error);
    }
  },

  getAssingClinic: async (payload, toast) => {
    set({ isLoading: true });
    try {
      await assignClinic(payload);
      toast.success("Clinic Deatils updated Successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  },

  getPatientsAssignedToClinics: async (startDate, endDate, clinicId) => {
    set({ clinicAppointmentLoading: true });
    try {
      const response = await getClinicAppointments(startDate, endDate, clinicId);
      set({ clinicAppointments: response.data, clinicAppointmentLoading:false });
    } catch (error) {
      set({ clinicAppointmentLoading:false });
      toast.error(error?.response?.data?.message);
    }
  },

  getDoctorOfTheClinic: async (adminId) => {
    set({ isLoading: true });
    try {
      const response = await doctorsOfClinic(adminId);
      set({ doctors: response.data });
    } catch (error) {
      console.error(error?.response?.data?.message);
    }
  },

  getCxAssignedClinic: async (caseId) => {
    set({ isLoading: true });
    try {
      const response = await cxAssignedClinic(caseId);
      set({ clinicsAssingedToCx: response.data });
    } catch (error) {
      console.error(error?.response?.data?.message);
    }
  },

  getAssignDoctorToCx: async (payload, toast) => {
    try {
      await assingDoctorToCX(payload);
      toast.success("Doctor added to the  Successfully");
    } catch (error) {
      console.error(error?.response?.data?.message);
    }
  },
  getClinicSlots: async (payload, toast) => {
    try {
      const response =  await clinicsSlots(payload);
      !response?.data?.doctorSlots?.length&&toast.warning("Doctor slot is not Available, Please Get the slot", TOAST_MESSAGE_CSS)
      set({ slots: response.data });
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  },

  bookClinicSlotsStore: async (payload, clinicId, toast, startDate,endDate) => {
    try {
      const response =  await bookClinicSlot(payload, clinicId);
      set({ slots: response.data });
      toast.success("Slot booked Successfully", TOAST_MESSAGE_CSS);
      await get().getPatientsAssignedToClinics(startDate, endDate);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  },
  clinicWritePrescription: async (payload, toast, handleClose) => {
    try {
      const response = await clinicPrescription(payload);
      set({ clinicPresRes : response.data });
      toast.success('Prescription written successfully', TOAST_MESSAGE_CSS);
      handleClose();
      get().getPatientsAssignedToClinics();
    } catch (error) {
      toast.error(error?.response?.data?.message, TOAST_MESSAGE_CSS);
    }
  },
  getPrescriptionData: async (case_id) => {
    try {
      set({ prescLoading: true });
      const response = await viewPrescriptionApi(case_id);
      set({ viewPrescriptionData: response.data, prescLoading:false });
    } catch (error) {
      set({ prescLoading: false });
      console.error(error.message);
    }
  },
  clinicEditPrescription: async (pres_id, payload, toast) => {
    try {
      await editPresApi(pres_id, payload);
      toast.success('Prescription Updated successfully', TOAST_MESSAGE_CSS);
      get().getPatientsAssignedToClinics();
    } catch (error) {
      toast.error(error?.response?.data?.message, TOAST_MESSAGE_CSS);
    }
  },
  uploadImagePres: async (pres_id, payload)=> {
    try {
      await uploadImagePres(pres_id, payload);
      toast.success('Prescription Updated successfully', TOAST_MESSAGE_CSS);
    } catch (error) {
      toast.error(error?.response?.data?.message, TOAST_MESSAGE_CSS);
    }
  },
  getClinicLocations: async ()=> {
    try {
      set({ locations: [] });
      const response = await getClinicLocationsApi();
      set({ locations: response.data.clinics });
    } catch (error) {
      toast.error(error?.response?.data?.message, TOAST_MESSAGE_CSS);
    }
  },
  updateClinicPayment: async (paymentId) => {
    try {
      await markPaid(paymentId);
      toast.success('Payment marked done', TOAST_MESSAGE_CSS);
    } catch (error) {
      toast.error(error?.response?.data?.message, TOAST_MESSAGE_CSS);
    }
  }
}));